import {
  Heading,
  Stack,
  Table,
  TableBody,
  TableHeader,
  TableHeaderCell,
  TableRow,
  Text,
} from 'braid-design-system';
import type { ComponentProps } from 'react';

interface Props {
  children: ComponentProps<typeof Stack>['children'];
  heading: string | null;

  subheading?: ComponentProps<typeof Stack>['children'];
  wrapper?: 'none' | 'table' | 'usage-table';
}

export const SchemaSection = ({
  children,
  heading,
  subheading,
  wrapper = 'table',
}: Props) => (
  <Stack space="xlarge">
    {typeof heading === 'string' && <Heading level="3">{heading}</Heading>}

    {subheading}

    {wrapper !== 'none' ? (
      <Table label={heading ?? ''} alignY="top">
        <TableHeader>
          <TableRow>
            <TableHeaderCell>
              <Text>Name</Text>
            </TableHeaderCell>
            <TableHeaderCell>
              <Text>Description</Text>
            </TableHeaderCell>
          </TableRow>
        </TableHeader>
        <TableBody>{children}</TableBody>
      </Table>
    ) : (
      children
    )}
  </Stack>
);
